<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll">
        <div class="privacy-policy-container">
            <!-- Header Section -->
            <!--
    <nav class="navbar container-fluid">
        <div class="row w-100 align-items-center">
            <div class="col-auto logo" routerLink="/">LOGO NAME</div>
            <div class="col text-end">
                <button class="back-btn" routerLink="/">
          <i class="bi bi-arrow-left"></i> Back to Home
        </button>
            </div>
        </div>
    </nav>
  -->

            <!-- Main Content -->
            <div class="container content-wrapper">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-xl-12">

                        <!-- Title Section -->
                        <div class="header-section text-center">
                            <h1 class="main-title">Privacy Policy</h1>
                            <p class="last-updated">Last Updated: December 2, 2024</p>
                            <div class="divider"></div>
                        </div>

                        <!-- Introduction -->
                        <section class="policy-section">
                            <div class="section-intro">
                                <p class="lead-text">
                                    This privacy notice for <strong>Jetya Software Pvt Ltd</strong> ("Company", "we", "us", or "our"), describes how and why we might collect, store, use, and/or share ("process") your information when you use our services
                                    ("Services"), such as when you visit our website at <a href="https://ryno.in" target="_blank">https://ryno.in</a>, download and use our mobile application "Ryno" or engage with us in other related ways, including any
                                    sales, marketing, or events.
                                </p>
                            </div>
                        </section>

                        <!-- Section 1: What Information Do We Collect -->
                        <section class="policy-section" id="section-1">
                            <h2 class="section-title">
                                <span class="section-number">1.</span> What Information Do We Collect?
                            </h2>
                            <div class="section-content">
                                <p>We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities
                                    on the Services, or otherwise when you contact us.</p>

                                <div class="subsection">
                                    <h3 class="subsection-title">Personal Information Collected</h3>
                                    <p>The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include
                                        the following:
                                    </p>

                                    <div class="info-card">
                                        <div class="card-icon">👤</div>
                                        <div class="card-content">
                                            <h4>Account Information</h4>
                                            <ul class="content-list">
                                                <li>Names</li>
                                                <li>Phone numbers</li>
                                                <li>Email addresses</li>
                                                <li>Usernames</li>
                                                <li>Passwords</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="info-card">
                                        <div class="card-icon">🆔</div>
                                        <div class="card-content">
                                            <h4>ID Proof Verification</h4>
                                            <p>We collect ID Proof to verify that you belong to our acceptable category of users.</p>
                                        </div>
                                    </div>

                                    <div class="alert-box info">
                                        <i class="bi bi-shield-check"></i>
                                        <div>
                                            <p><strong>Important Notice:</strong> We do not store any ID proofs or use it for any other purposes other than verifying your identity. We delete them from our systems as soon as the account is activated.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Automatically Collected Information</h3>
                                    <p>In addition, we may collect certain information automatically, including, but not limited to:</p>
                                    <ul class="content-list">
                                        <li>The type of mobile device you use</li>
                                        <li>Your mobile device's unique device ID</li>
                                        <li>The IP address of your mobile device</li>
                                        <li>Your mobile operating system</li>
                                        <li>The type of mobile Internet browsers you use</li>
                                        <li>Information about the way you use the Services</li>
                                    </ul>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Payment Data</h3>
                                    <div class="payment-info-box">
                                        <i class="bi bi-credit-card"></i>
                                        <div>
                                            <p><strong>Important:</strong> We do not collect any data necessary to process your payment. All payments are processed by Razorpay.</p>
                                            <p class="mt-2">You may find their privacy notice at: <a href="https://razorpay.com/privacy/" target="_blank" class="external-link">Razorpay's Privacy Policy</a></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert-box warning">
                                    <i class="bi bi-exclamation-triangle"></i>
                                    <div>
                                        <p><strong>Accuracy of Information:</strong> All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Section 2: How Do We Process Your Information -->
                        <section class="policy-section" id="section-2">
                            <h2 class="section-title">
                                <span class="section-number">2.</span> How Do We Process Your Information?
                            </h2>
                            <div class="section-content">
                                <p>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</p>

                                <div class="process-grid">
                                    <div class="process-item">
                                        <div class="process-number">i</div>
                                        <div class="process-content">
                                            <h4>Account Management</h4>
                                            <p>We may process your information so you can create and login to your account, as well as keep your account in working order.</p>
                                        </div>
                                    </div>

                                    <div class="process-item">
                                        <div class="process-number">ii</div>
                                        <div class="process-content">
                                            <h4>Service Provision</h4>
                                            <p>We may process your information to provide you with the requested service.</p>
                                        </div>
                                    </div>

                                    <div class="process-item">
                                        <div class="process-number">iii</div>
                                        <div class="process-content">
                                            <h4>Customer Support</h4>
                                            <p>We may process your information to respond to your inquiries and solve any potential issues you might have with the requested service.</p>
                                        </div>
                                    </div>

                                    <div class="process-item">
                                        <div class="process-number">iv</div>
                                        <div class="process-content">
                                            <h4>Communications</h4>
                                            <p>We may process your information to send you details about our products and services, changes to our terms and policies, and other similar information.</p>
                                        </div>
                                    </div>

                                    <div class="process-item">
                                        <div class="process-number">v</div>
                                        <div class="process-content">
                                            <h4>Service Improvement</h4>
                                            <p>We may process your information when we believe it is necessary to identify usage trends, determine the effectiveness of our promotional campaigns, and to evaluate and improve our Services, products, marketing,
                                                and your experience.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Section 3: When and With Whom Do We Share Your Personal Information -->
                        <section class="policy-section" id="section-3">
                            <h2 class="section-title">
                                <span class="section-number">3.</span> When and With Whom Do We Share Your Personal Information?
                            </h2>
                            <div class="section-content">
                                <div class="alert-box info">
                                    <i class="bi bi-shield-check"></i>
                                    <div>
                                        <p><strong>Data Privacy Commitment:</strong> Only aggregated, anonymized data is transmitted to external services to help us improve the service. We will share your information with third parties only in the ways that
                                            are described in this privacy statement.</p>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Information Disclosure</h3>
                                    <p>We may disclose User Provided and Automatically Collected Information:</p>

                                    <div class="disclosure-item">
                                        <div class="disclosure-icon">⚖️</div>
                                        <div class="disclosure-content">
                                            <h4>Legal Compliance</h4>
                                            <p>As required by law, such as to comply with a subpoena, or similar legal process.</p>
                                        </div>
                                    </div>

                                    <div class="disclosure-item my-5">
                                        <div class="disclosure-icon">🛡️</div>
                                        <div class="disclosure-content">
                                            <h4>Safety and Security</h4>
                                            <p>When we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request.</p>
                                        </div>
                                    </div>

                                    <div class="disclosure-item">
                                        <div class="disclosure-icon">🏢</div>
                                        <div class="disclosure-content">
                                            <h4>Business Transfers</h4>
                                            <p>If Jetya Software Pvt Ltd is involved in a merger, acquisition, or sale of all or a portion of its assets, you will be notified via email and/or a prominent notice on our website of any change in ownership or
                                                uses of this information, as well as any choices you may have regarding this information.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Section 4: How Long Do We Keep Your Information -->
                        <section class="policy-section" id="section-4">
                            <h2 class="section-title">
                                <span class="section-number">4.</span> How Long Do We Keep Your Information?
                            </h2>
                            <div class="section-content">
                                <div class="retention-overview">
                                    <div class="retention-card">
                                        <i class="bi bi-clock-history"></i>
                                        <h4>User Provided Data</h4>
                                        <p>We will retain User Provided data for as long as you use our Services and for a reasonable time thereafter.
                                        </p>
                                    </div>

                                    <div class="retention-card">
                                        <i class="bi bi-calendar3"></i>
                                        <h4>Automatically Collected Information</h4>
                                        <p>We will retain Automatically Collected information for up to <strong>12 months</strong> and thereafter may store it in aggregate.</p>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Data Deletion Request</h3>
                                    <p>If you'd like us to delete User Provided Data that you have provided via the Services, please contact us at
                                        <a href="mailto:jetyasoftware@gmail.com" class="email-link">jetyasoftware&#64;gmail.com</a> and we will respond in a reasonable time.
                                    </p>

                                    <div class="alert-box warning">
                                        <i class="bi bi-info-circle"></i>
                                        <div>
                                            <p><strong>Please note:</strong> Some or all of the User Provided Data may be required in order for the Application to function properly.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Data Disposal</h3>
                                    <p>When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information
                                        has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.</p>
                                </div>
                            </div>
                        </section>

                        <!-- Section 5: How Do We Keep Your Information Safe -->
                        <section class="policy-section" id="section-5">
                            <h2 class="section-title">
                                <span class="section-number">5.</span> How Do We Keep Your Information Safe?
                            </h2>
                            <div class="section-content">
                                <p>We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process.</p>

                                <div class="security-notice">
                                    <i class="bi bi-shield-exclamation"></i>
                                    <div>
                                        <h4>Security Disclaimer</h4>
                                        <p>However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or
                                            guarantee that hackers, cyber-criminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.</p>
                                        <p class="mt-3"><strong>Although we will do our best to protect your personal information, transmission
                    of personal information to and from our Services is at your own risk. You should only access the
                    Services within a secure environment.</strong></p>
                                    </div>
                                </div>

                                <div class="row security-tips mt-4">
                                    <div class="col-md-4">
                                        <div class="tip-box">
                                            <i class="bi bi-key-fill"></i>
                                            <h5>Use Strong Passwords</h5>
                                            <p>Create unique, complex passwords</p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="tip-box">
                                            <i class="bi bi-wifi"></i>
                                            <h5>Secure Network</h5>
                                            <p>Access services on secure networks</p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="tip-box">
                                            <i class="bi bi-lock-fill"></i>
                                            <h5>Keep Info Private</h5>
                                            <p>Don't share login credentials</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Section 6: Do We Collect Information From Minors -->
                        <section class="policy-section" id="section-6">
                            <h2 class="section-title">
                                <span class="section-number">6.</span> Do We Collect Information From Minors?
                            </h2>
                            <div class="section-content">
                                <div class="alert-box warning">
                                    <i class="bi bi-exclamation-triangle-fill"></i>
                                    <div>
                                        <p><strong>Age Restriction:</strong> We do not knowingly solicit data from or market to children under 18 years of age.</p>
                                        <p class="mt-2">Since our services are restricted to a specific category of users, it is evident by default that the users are above 18 years of age.</p>
                                        <p class="mt-2"><strong>If we learn that personal information from users less than 18 years of age has
                    been collected, we will deactivate the account and take reasonable measures to promptly delete such
                    data from our records.</strong></p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Section 7: Account Information -->
                        <section class="policy-section" id="section-7">
                            <h2 class="section-title">
                                <span class="section-number">7.</span> Account Information
                            </h2>
                            <div class="section-content">
                                <div class="account-actions">
                                    <div class="action-card">
                                        <i class="bi bi-pencil-square"></i>
                                        <h4>Review or Change Information</h4>
                                        <p>If you would at any time like to review or change the information in your account, you can contact us via email.</p>
                                    </div>

                                    <div class="action-card">
                                        <i class="bi bi-trash-fill"></i>
                                        <h4>Terminate Account</h4>
                                        <p>If you would like to terminate your account, you can contact us via email.</p>
                                    </div>
                                </div>

                                <div class="contact-box mt-4">
                                    <i class="bi bi-envelope-fill"></i>
                                    <div>
                                        <p>
                                            <strong>Contact Email: </strong> <a href="mailto:jetyasoftware@gmail.com" class="email-link">jetyasoftware&#64;gmail.com</a>
                                        </p>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <h3 class="subsection-title">Account Termination Process</h3>
                                    <p>Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases.</p>

                                    <div class="alert-box info">
                                        <i class="bi bi-info-circle"></i>
                                        <div>
                                            <p><strong>Data Retention Notice:</strong> However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with
                                                applicable legal requirements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Contact Section -->
                        <section class="policy-section" id="section-contact">
                            <h2 class="section-title">
                                <span class="section-number">8.</span> Contact Us
                            </h2>
                            <div class="section-content">
                                <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:</p>

                                <div class="contact-info-grid">
                                    <div class="contact-card">
                                        <i class="bi bi-building"></i>
                                        <h4>Company Name</h4>
                                        <p>Jetya Software Pvt Ltd</p>
                                    </div>

                                    <div class="contact-card">
                                        <i class="bi bi-envelope-fill"></i>
                                        <h4>Email</h4>
                                        <p><a href="mailto:jetyasoftware@gmail.com" class="email-link">jetyasoftware&#64;gmail.com</a></p>
                                    </div>

                                    <div class="contact-card">
                                        <i class="bi bi-globe"></i>
                                        <h4>Website</h4>
                                        <p><a href="https://ryno.in" target="_blank" class="external-link">https://ryno.in</a></p>
                                    </div>

                                    <div class="contact-card">
                                        <i class="bi bi-phone-fill"></i>
                                        <h4>Mobile App</h4>
                                        <p>Ryno Application</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Acknowledgment Section -->
                        <section class="policy-section acknowledgment-section">
                            <div class="acknowledgment-box">
                                <i class="bi bi-check-circle-fill"></i>
                                <h3>Acknowledgment</h3>
                                <p>By using the Services provided by Jetya Software Pvt Ltd, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</p>
                            </div>
                        </section>

                    </div>
                </div>
            </div>

            <!-- Footer -->
            <!--
    <footer class="footer">
      <div class="container-fluid">
        <div class="footer-content">
          <div class="footer-links">
            <a routerLink="/" class="footer-link">Home</a>
            <a routerLink="/privacy-policy" class="footer-link active">Privacy Policy</a>
            <a routerLink="/terms-condition" class="footer-link">Terms & Condition</a>
            <a href="mailto:jetyasoftware@gmail.com" class="footer-link">Contact Us</a>
          </div>
          <div class="footer-copyright">
            <p>&copy; 2024 Jetya Software Pvt Ltd. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  -->
        </div>
    </div>
</div>